import React, { useContext, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { paperStyle } from '../../lib/styles';
import { HomeItemContainer } from './home_item';
import { PlaceholderContainer } from './placeholder';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ApiContext } from './context';
import * as MainOrderEditMutation from '../../mutations/MainOrderEditMutation';
import modernEnvironment from '../../lib/RelayUtils';

const HomeSection = props => {
	const queryAttr = 'data-rbd-drag-handle-draggable-id';
	const [placeholderProps, setPlaceholderProps] = useState({});

	const handleDragStart = event => {
		const draggedDOM = getDraggedDom(event.draggableId);

		if (!draggedDOM) {
			return;
		}

		const { clientHeight, clientWidth } = draggedDOM;
		const sourceIndex = event.source.index;
		const clientY =
			parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
			[...draggedDOM.parentNode.children].slice(0, sourceIndex).reduce((total, curr) => {
				const style = curr.currentStyle || window.getComputedStyle(curr);
				const marginBottom = parseFloat(style.marginBottom);
				return total + curr.clientHeight + marginBottom;
			}, 0);

		setPlaceholderProps({
			clientHeight,
			clientWidth,
			clientY,
			clientX: parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingLeft),
		});
	};

	const handleDragUpdate = event => {
		if (!event.destination) {
			return;
		}

		const draggedDOM = getDraggedDom(event.draggableId);

		if (!draggedDOM) {
			return;
		}

		const { clientHeight, clientWidth } = draggedDOM;
		const destinationIndex = event.destination.index;
		const sourceIndex = event.source.index;

		const childrenArray = [...draggedDOM.parentNode.children];
		const movedItem = childrenArray[sourceIndex];
		childrenArray.splice(sourceIndex, 1);

		const updatedArray = [...childrenArray.slice(0, destinationIndex), movedItem, ...childrenArray.slice(destinationIndex + 1)];

		const clientY =
			parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
			updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
				const style = curr.currentStyle || window.getComputedStyle(curr);
				const marginBottom = parseFloat(style.marginBottom);
				return total + curr.clientHeight + marginBottom;
			}, 0);

		setPlaceholderProps({
			clientHeight,
			clientWidth,
			clientY,
			clientX: parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingLeft),
		});
	};

	const getDraggedDom = draggableId => {
		const domQuery = `[${queryAttr}='${draggableId}']`;
		return document.querySelector(domQuery);
	};

	const { edges = [], viewer, title, limit = 3, uuid, placeholderHint } = props;
	const list = Array.apply(null, Array(limit)).map((el, index) => {
		const mainPageOrder = index + 1;
		const edge = edges.find(edge => edge.node.mainPageOrder === mainPageOrder);
		return edge ? (
			<HomeItemContainer section={props.section} key={edge.node.id} node={edge.node} index={index} />
		) : (
			<PlaceholderContainer key={`placeholder${index}`} section={props.section} hint={placeholderHint} viewer={viewer} order={mainPageOrder} />
		);
	});

	const handleDragEnd = result => {
		setPlaceholderProps({});
		// dropped outside the list
		if (!result.destination) {
			return;
		}
		const to = result.destination.index;
		const from = result.source.index;
		if (from !== to) {
			props.onDragEnd(from, to);
		}
	};

	return (
		<Paper style={paperStyle.mainItem}>
			<h3>{title}</h3>
			<div className="section-inner">
				<DragDropContext onDragStart={handleDragStart} onDragUpdate={handleDragUpdate} onDragEnd={handleDragEnd}>
					<Droppable droppableId={uuid}>
						{(provided, snapshot) => (
							<React.Fragment>
								<div {...provided.droppableProps} ref={provided.innerRef}>
									{list}
								</div>
								{provided.placeholder}
								{placeholderProps && snapshot.isDraggingOver && (
									<div
										className="drag-placeholder"
										style={{
											top: placeholderProps.clientY,
											left: placeholderProps.clientX,
											height: placeholderProps.clientHeight,
											width: placeholderProps.clientWidth,
										}}
									/>
								)}
							</React.Fragment>
						)}
					</Droppable>
				</DragDropContext>
			</div>
		</Paper>
	);
};

export const HomeSectionContainer = props => {
	const { refetch } = useContext(ApiContext);

	const handleDragEnd = (from, to) => {
		const fromEdge = props.edges[from];
		const toEdge = props.edges[to];
		const fromIndex = from + 1;
		const toIndex = to + 1;
		console.log('handleDragEnd', from, to, fromEdge, toEdge);
		const input = {
			fromId: fromEdge.node.id,
			toId: toEdge.node.id,
			fromIndex,
			toIndex,
		};
		MainOrderEditMutation.commit(modernEnvironment, input, () => {
			refetch();
		});
	};
	return (
		<div className="section-wrapper">
			<HomeSection {...props} onDragEnd={handleDragEnd} />
		</div>
	);
};



// WEBPACK FOOTER //
// src/components/home/home_section.js